var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMagic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_981_6406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7969 8.25958L17.7175 7.40279C17.3417 7.29825 17.1538 7.24595 17.0004 7.14347C16.8646 7.05277 16.749 6.934 16.661 6.79481C16.5616 6.63759 16.5115 6.44544 16.4115 6.06116L15.5914 2.91208L14.7518 6.05599C14.6493 6.43965 14.5981 6.63147 14.4977 6.78808C14.4088 6.92671 14.2925 7.04476 14.1561 7.13461C14.0021 7.23614 13.8139 7.28727 13.4375 7.38946L10.3528 8.22706L13.4322 9.08385C13.808 9.18839 13.9959 9.24069 14.1492 9.34317C14.285 9.43389 14.4006 9.55265 14.4886 9.6918C14.5881 9.84906 14.6381 10.0412 14.7382 10.4255L15.5582 13.5746L16.3979 10.4306C16.5003 10.047 16.5516 9.85517 16.652 9.69853C16.7408 9.55993 16.8572 9.4419 16.9935 9.35203C17.1475 9.2505 17.3358 9.19937 17.7122 9.09718L20.7969 8.25958Z",
    fill: "fillContainer"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_981_6406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38465 6.96074L6.78194 6.56295C6.58637 6.51442 6.48858 6.49014 6.40872 6.4426C6.33806 6.40052 6.27788 6.34543 6.23205 6.28089C6.18028 6.20797 6.1542 6.11888 6.10206 5.94069L5.67475 4.48052L5.23835 5.93801C5.1851 6.11586 5.15846 6.20479 5.10624 6.27738C5.06002 6.34164 4.99949 6.39635 4.92855 6.43799C4.84842 6.48503 4.75048 6.5087 4.5546 6.55602L2.94945 6.94381L4.55215 7.3416C4.74773 7.39013 4.84552 7.41441 4.92536 7.46195C4.99604 7.50404 5.05623 7.55912 5.10205 7.62365C5.15382 7.69658 5.1799 7.78567 5.23204 7.96385L5.65935 9.42403L6.09575 7.96654C6.149 7.78869 6.17564 7.69976 6.22786 7.62716C6.27409 7.56291 6.33461 7.50821 6.40553 7.46656C6.48569 7.41952 6.58362 7.39585 6.7795 7.34853L8.38465 6.96074Z",
    fill: "fillContainer"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_981_6406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1024 14.8269L10.8398 14.2769C10.5636 14.2098 10.4256 14.1762 10.3128 14.1105C10.2131 14.0523 10.1281 13.9762 10.0634 13.8869C9.99032 13.7861 9.95349 13.663 9.87987 13.4167L9.27647 11.3981L8.66051 13.4129C8.58535 13.6587 8.54775 13.7817 8.47403 13.882C8.40879 13.9708 8.32334 14.0464 8.22319 14.104C8.11006 14.169 7.9718 14.2017 7.69527 14.2671L5.42921 14.803L7.69189 15.3531C7.96801 15.4202 8.10606 15.4537 8.21878 15.5195C8.31857 15.5777 8.40355 15.6538 8.46824 15.743C8.54133 15.8438 8.57816 15.967 8.65179 16.2133L9.25519 18.2318L9.87114 16.2171C9.9463 15.9713 9.9839 15.8483 10.0576 15.748C10.1229 15.6592 10.2083 15.5835 10.3084 15.526C10.4216 15.461 10.5599 15.4282 10.8364 15.3629L13.1024 14.8269Z",
    fill: "fillContainer"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_981_6406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.0697,
    height: 22.3304,
    fill: "white",
    transform: "matrix(0.003114 -0.999995 -0.999995 -0.003114 22.6191 21.0646)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_981_6406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.59138,
    height: 7.24697,
    fill: "white",
    transform: "matrix(0.003114 -0.999995 -0.999995 -0.003114 9.28027 10.2593)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_981_6406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.11162,
    height: 10.231,
    fill: "white",
    transform: "matrix(0.003114 -0.999995 -0.999995 -0.003114 14.3672 19.3867)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagic);
export default __webpack_public_path__ + "static/media/icon-magic.0d7483f7ed14b7935091a26342c83c12.svg";
export { ForwardRef as ReactComponent };